import { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { NAV, slug } from "@/data/nav";
import { comingSoon } from "@/lib/site";
import { BookMeeting } from "./Cta";

const SubLink = ({ it }) => {
  const cls = "flex w-full items-center justify-between py-2.5 text-left text-[15px] text-slate-300 hover:text-white";
  const tid = `mobile-item-${slug(it.label)}`;
  const tag = it.soon && <span className="font-mono text-[10px] uppercase tracking-wider text-slate-500">Soon</span>;
  return it.to
    ? <Link to={it.to} data-testid={tid} className={cls}>{it.label}</Link>
    : <button type="button" data-testid={tid} className={cls} onClick={() => comingSoon(it.label)}>{it.label}{tag}</button>;
};

const Group = ({ item }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-white/10">
      <button type="button" data-testid={`mobile-group-${slug(item.label)}`} onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between py-4 font-display text-2xl text-white">
        {item.label}
        <Plus className={`h-5 w-5 text-violet-300 transition-transform duration-300 ${open ? "rotate-45" : ""}`} />
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div initial={{ height: 0 }} animate={{ height: "auto" }} exit={{ height: 0 }} className="overflow-hidden">
            <div className="pb-4 pl-1">{item.items.map((it) => <SubLink key={it.label} it={it} />)}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export const MobileMenu = ({ open }) => (
  <AnimatePresence>
    {open && (
      <motion.div data-testid="mobile-menu" data-lenis-prevent initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        className="fixed inset-x-0 bottom-0 top-[72px] z-50 overflow-y-auto bg-[#0B0716] px-5 pb-10 sm:px-8 lg:hidden">
        {NAV.map((item) => item.items ? <Group key={item.label} item={item} /> : (
          <div key={item.label} className="border-b border-white/10">
            {item.to
              ? <Link to={item.to} data-testid={`mobile-link-${slug(item.label)}`} className="block py-4 font-display text-2xl text-white">{item.label}</Link>
              : item.href
              ? <a href={item.href} target="_blank" rel="noopener noreferrer" data-testid={`mobile-link-${slug(item.label)}`} className="block py-4 font-display text-2xl text-white">{item.label} ↗</a>
              : <button type="button" data-testid={`mobile-link-${slug(item.label)}`} onClick={() => comingSoon(item.label)}
                  className="block w-full py-4 text-left font-display text-2xl text-white">{item.label}{item.external ? " ↗" : ""}</button>}
          </div>
        ))}
        <BookMeeting testid="mobile-book-meeting-cta" className="mt-8 w-full" />
      </motion.div>
    )}
  </AnimatePresence>
);
